<template>
	<v-container grid-list-xl>
		<v-form v-model="isAddValid">
			<v-layout row wrap>
				<v-flex lg6>
					<label class="blackLabel">Region Type:</label>
					<v-select :items="regionTypes" @input="fncCheckTypes()" label="Type" v-model="regionType" :rules="typeRules" single-line solo></v-select>
				</v-flex>
				<v-flex lg6>
					<label class="blackLabel">Region Link:</label>
					<v-select :items="regionParents" label="Link Under"v-model="regionLink" required :rules="linkRules" autocomplete single-line solo></v-select>
				</v-flex>
				<v-flex lg6>
					<label class="blackLabel">Region Name:</label>
					<v-text-field label="Region Name" v-model="regionName" single-line required :rules="nameRules" solo></v-text-field>
				</v-flex>
				<v-flex lg6>
					<label class="blackLabel">Region Description:</label>
					<v-text-field label="Region Description" v-model="regionDescription" :rules="descriptionRules" single-line solo></v-text-field>
				</v-flex>
				<div class="pl-4 pr-1 pb-4 buttonHolder">
					<div style="float: right">
						<v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
						<v-progress-circular indeterminate :width="3" :size="20" v-if="runAdd" color="grey" class="pt-3 loginLoader"></v-progress-circular>
						<v-btn color="success" class="text-xs-right" v-if="!runAdd" :disabled="!isAddValid" @click.stop="fncAddRegion()">Save</v-btn>
                        <small>* The button will activate once all required fields have been completed.</small>
					</div>
				</div>
			</v-layout>
		</v-form>
	</v-container>
</template>

<script>
	import { mapGetters } from 'vuex';
	export default {
	  name: 'RegionAdd',
	  data () {
			return {
				isAddValid: false,
				regionLink: '',
				regionName: '',
				regionDescription: '',
				regionType: '',
				regionTypes: [
					{ text: 'Continent' },
					{ text: 'Country' },
					{ text: 'Province' },
					{ text: 'District' },
					{ text: 'Town' },
					{ text: 'Suburb' }
				],
				linkRules: [
					v => !!v || 'Region link is required',
				],
				nameRules: [
					v => !!v || 'Region name is required',
				],
				descriptionRules: [
					v => !!v || 'Region description is required',
				],
				typeRules: [
					v => !!v || 'Region type is required',
				]
			};
		},
		methods: {
			fncCheckTypes() {
				this.$store.dispatch({
					type: 'setObjRegionParents',
					regionType: this.regionType.text
				});
				this.regionLink = '';
			},
			fncHideModal () {
				this.$store.commit('hideModal');
			},
			fncAddRegion() {
				this.$store.dispatch({
					type: 'fncAddRegion',
					regionLink: this.regionLink.id,
					regionName: this.regionName,
					regionDescription: this.regionDescription,
					regionType: this.regionType.text
				});
			}
		},
		computed: {
			...mapGetters([
				'objAuthorize',
				'globalModalParams',
				'runAdd',
				'regionSelectors',
				'regionParents'
			])
		},
		mounted(){
			this.$store.commit('setRegionSelectors');
		},
		watch: {
	      runAdd() {
	          if( this.runAdd === false ) {
                  this.isAddValid = false;
				  this.regionLink = '';
				  this.regionName = '';
				  this.regionDescription = '';
				  this.regionType = '';
			  }
		  }
		}
	}
</script>

<style scoped>
	/*@import '../../assets/css/shared.css'*/
</style>
